module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qresp4-6bda5a169d7d0539698b7f89144e92ad.jpg";